import { useRscCompatibleRef } from "./useRscCompatibleRef.js";
import { isRsc } from "./reactVersion.js";
import deepEqual from "fast-deep-equal";

/**
 * Use an object that is unstable across renders.
 * This hook will perform a deep comparison and only change
 * the value if the new value is different from the previous value.
 *
 * @group React Hooks
 */
export const useUnstableReference = value => {
  /* eslint-disable react-hooks/rules-of-hooks */
  if (isRsc) {
    return value;
  }
  const ref = useRscCompatibleRef(value);
  if (!deepEqual(ref.current, value)) {
    ref.current = value;
  }
  return ref.current;
};